var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 10C21.334 17 12.334 23 12.334 23C12.334 23 3.33398 17 3.33398 10C3.33398 7.61305 4.2822 5.32387 5.97002 3.63604C7.65785 1.94821 9.94704 1 12.334 1C14.7209 1 17.0101 1.94821 18.6979 3.63604C20.3858 5.32387 21.334 7.61305 21.334 10Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 13C13.9908 13 15.334 11.6569 15.334 10C15.334 8.34315 13.9908 7 12.334 7C10.6771 7 9.33398 8.34315 9.33398 10C9.33398 11.6569 10.6771 13 12.334 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.39669e96a1eefd0b8877c8e05d1c5801.svg";
export { ForwardRef as ReactComponent };